import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 12.25H17.9375",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 15.75H17.9375",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4375 23.625H5.25C5.01794 23.625 4.79538 23.5328 4.63128 23.3687C4.46719 23.2046 4.375 22.9821 4.375 22.75V13.5625C4.375 10.8938 5.43515 8.33432 7.32224 6.44724C9.20932 4.56015 11.7688 3.5 14.4375 3.5C15.7589 3.5 17.0674 3.76027 18.2883 4.26596C19.5091 4.77165 20.6184 5.51285 21.5528 6.44724C22.4872 7.38163 23.2283 8.49091 23.734 9.71175C24.2397 10.9326 24.5 12.2411 24.5 13.5625C24.5 14.8839 24.2397 16.1924 23.734 17.4133C23.2283 18.6341 22.4872 19.7434 21.5528 20.6778C20.6184 21.6122 19.5091 22.3533 18.2883 22.859C17.0674 23.3647 15.7589 23.625 14.4375 23.625Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgMessage as ReactComponent };
